
import { Navigate, useNavigate } from 'react-router-dom';
import PieChart from './graficos/PieChart';
import ProgressBar from './ProgressBar';

function SituacaoEnvioURDF(props) {
  const x = props?.situacao || []
  console.log(x)
  console.log("x.length")
  console.log(x.length)

  const navigate = useNavigate()
  const click = () => {
    // console.log('x=>',x);
    // console.log('operacao=>',props.operacao_id);
    // console.log('id_entidade=>',x.id_entidade);
    // console.log("PROPS=>",props)


   
      navigate("/api-fo-sp/situacao/objetos", { state: { id_entidade: x.id_entidade || -1, operacao_id: props.operacao_id, area:x.area } })
      // navigate("/api-fo-nacional/situacao/objetos", { state: { entidade_id: x.id_entidade || -1 } })
  }

  const valor = getRespondidasNumerico(x.respondidas, x.total)
  const box_style = {
    backgroundColor: boxBgColor(valor), 
    border: '1px solid ' + boxBorderColor(valor) 
  }

  return (<div key={x?.[0]?.area + Math.random() * 1000} className="grafico15-small bg-grey-card sombra weight-600" style={ box_style } onClick={click} >
    {x?.area}
    <br />
    {/* <strong>{getRespondidasPercentual(x.respondidas, x.total)}%</strong> */}
    {/* <PieChart height="150px" colors={["#03BC00", "#F3BC00"]} titulo="" labelY="Quantidade" labelX={["asdasd", "asd"]}
      dados={getPieData(x, 'entidade')} click={props?.situacaoClick}
      showLabels={true} legend={true} showPercentual bgColor="#faf7e7" /> */
      }
      <div style={{width:'100%'}}>
        {/* <img style={{width:"40%"}} src={process.env.PUBLIC_URL + "/img/flags/estados/"+ getRamdom(x.estado_id) + '.png'} /> */}
        {/* <img style={{width:"40%"}} src={process.env.PUBLIC_URL + "/img/flags/estados/"+ x.estado_id + '.png'} /> */}
        <ProgressBar  completed={getRespondidasNumerico(x.respondidas, x.total)} colorSchema={colorSchema} />
        {/* <ProgressBar   completed={Math.ceil(Math.random()*100)} colorSchema={colorSchema} /> */}
      </div>
  </div>)
}

const getRamdom = ()=> {
  const array = ['11' ,'14','17','23','26','29','33','42','51'
,'12','15','21','24','27','31','35','43','52'
,'13','16','22','25','28','32','41','50','53'
    ]
  const randomElement = array[Math.floor(Math.random() * array.length)];
  return randomElement
}

const colorSchema = (valor) => {
  if (valor) {
    valor = parseInt(valor)
  }
  if (valor >= 0 && valor <= 100) {
    switch (true) {
      case valor >= 0 && valor < 10: return 'indianred'
      case valor >= 10 && valor < 20: return 'goldenrod'
      case valor >= 20 && valor < 30: return 'goldenrod'
      case valor >= 30 && valor < 40: return 'goldenrod'
      case valor >= 40 && valor < 50: return 'goldenrod'
      case valor >= 50 && valor < 60: return 'goldenrod'
      case valor >= 60 && valor < 70: return 'goldenrod'
      case valor >= 70 && valor < 80: return 'goldenrod'
      case valor >= 80 && valor < 90: return 'goldenrod'
      case valor >= 90 && valor < 100: return 'goldenrod'
      case valor === 100: return 'green'
    }
  }
  return 'black'
}

const boxBgColor = (valor) => {
  if(valor) {
    valor = parseInt(valor)
  }
  if(valor >= 0 && valor <= 100 ) {
    switch(true) {
      case valor === 0: return '#f9d9d9'
      case valor  > 0 && valor < 10: return 'beige'
      case valor >=10 && valor < 20: return 'beige'
      case valor >=20 && valor < 30: return 'beige'
      case valor >=30 && valor < 40: return 'beige'
      case valor >=40 && valor < 50: return 'beige'
      case valor >=50 && valor < 60: return 'beige'
      case valor >=60 && valor < 70: return 'beige'
      case valor >=70 && valor < 80: return 'beige'
      case valor >=80 && valor < 90: return 'beige'
      case valor >=90 && valor < 100: return 'beige'
      case valor === 100: return '#f2fff2'
    }
  }
  return 'black'
}

const boxBorderColor = (valor) => {
  if(valor) {
    valor = parseInt(valor)
  }
  if(valor >= 0 && valor <= 100 ) {
    switch(true) {
      case valor === 0: return 'indianred'
      case valor >0 && valor < 10: return 'gold'
      case valor >=10 && valor < 20: return 'gold'
      case valor >=20 && valor < 30: return 'gold'
      case valor >=30 && valor < 40: return 'gold'
      case valor >=40 && valor < 50: return 'gold'
      case valor >=50 && valor < 60: return 'gold'
      case valor >=60 && valor < 70: return 'gold'
      case valor >=70 && valor < 80: return 'gold'
      case valor >=80 && valor < 90: return 'gold'
      case valor >=90 && valor < 100: return 'gold'
      case valor === 100: return 'lightgreen'
    }
  }
  return 'black'
}

const getRespondidasPercentual = (parte, todo) => {
  const respondidas = parseInt(parte) || 0
  const respondidas_total = parseInt(todo) || 1

  let valor = respondidas / respondidas_total
  valor = valor * 100
  valor = valor.toLocaleString('pt-BR', {
    minimumIntegerDigits: 2,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })
  return valor
}

const getRespondidasNumerico = (parte, todo) => {
  const respondidas = parseInt(parte) || 0
  const respondidas_total = parseInt(todo) || 1

  let valor = respondidas / respondidas_total
  valor = valor * 100
 
  return Math.round((valor + Number.EPSILON) * 100) / 100
}

const getPieData = (dado, tipo) => {

  const nao_respondidas = dado?.total - dado?.respondidas
  if (tipo === 'objeto') {
    return [
      { name: 'Respondidas', y: dado?.respondidas, id_objeto: dado.id_objeto },
      { name: 'Não Respondidas', y: nao_respondidas, id_objeto: dado.id_objeto }
    ]
  } else if (tipo === 'entidade') {
    console.log(dado)
    return [
      { name: 'Respondidas', y: dado?.respondidas, id_entidade: dado.id_entidade },
      { name: 'Não Respondidas', y: nao_respondidas, id_entidade: dado.id_entidade }
    ]
  }
}


export default SituacaoEnvioURDF;
